var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "reveal-kg-workspace biomarker-network" }, [
    _c("header", { staticClass: "rkw-header" }, [
      _c("div", { staticClass: "rkw-brand" }, [
        _c("span", { staticClass: "rkw-mark" }, [
          _vm._v(_vm._s(_vm.isReverseSearch ? "BiomarkerKB" : "CFDE KG")),
        ]),
        _c("span", { staticClass: "rkw-title" }, [
          _vm._v(_vm._s(_vm.searchDirectionTitle)),
        ]),
      ]),
      _c("div", { staticClass: "bn-header-ops" }, [
        _c("div", { staticClass: "bn-ops-menu" }, [
          _c(
            "button",
            {
              staticClass: "bn-ops-menu-toggle",
              attrs: { type: "button", "aria-haspopup": "true" },
            },
            [_vm._v(" Search direction ")]
          ),
          _c(
            "div",
            {
              staticClass: "bn-ops-menu-list bn-ops-menu-list--direction",
              attrs: { role: "menu" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "bn-ops-menu-item",
                  class: { "bn-ops-menu-item--active": _vm.isForwardSearch },
                  attrs: {
                    type: "button",
                    role: "menuitemradio",
                    "aria-checked": _vm.isForwardSearch ? "true" : "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSearchDirection(
                        _vm.SEARCH_DIRECTION_FORWARD
                      )
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "bn-ops-menu-check",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.isForwardSearch ? "✓" : ""))]
                  ),
                  _vm._v(" CFDE KG → BiomarkerKB "),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "bn-ops-menu-item",
                  class: { "bn-ops-menu-item--active": _vm.isReverseSearch },
                  attrs: {
                    type: "button",
                    role: "menuitemradio",
                    "aria-checked": _vm.isReverseSearch ? "true" : "false",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setSearchDirection(
                        _vm.SEARCH_DIRECTION_REVERSE
                      )
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "bn-ops-menu-check",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v(_vm._s(_vm.isReverseSearch ? "✓" : ""))]
                  ),
                  _vm._v(" BiomarkerKB → CFDE KG "),
                ]
              ),
            ]
          ),
        ]),
        _c("div", { staticClass: "bn-ops-menu" }, [
          _c(
            "button",
            {
              staticClass: "bn-ops-menu-toggle",
              attrs: { type: "button", "aria-haspopup": "true" },
            },
            [_vm._v(" Session ")]
          ),
          _c(
            "div",
            { staticClass: "bn-ops-menu-list", attrs: { role: "menu" } },
            [
              _c(
                "button",
                {
                  staticClass: "bn-ops-menu-item",
                  attrs: { type: "button", role: "menuitem" },
                  on: { click: _vm.resetSearch },
                },
                [_vm._v(" Reset search ")]
              ),
              _c(
                "button",
                {
                  staticClass: "bn-ops-menu-item",
                  attrs: { type: "button", role: "menuitem" },
                  on: { click: _vm.triggerSessionImport },
                },
                [_vm._v(" Import session ")]
              ),
              _c(
                "button",
                {
                  staticClass: "bn-ops-menu-item",
                  attrs: {
                    type: "button",
                    role: "menuitem",
                    disabled: !_vm.canExportSession,
                  },
                  on: { click: _vm.exportSession },
                },
                [_vm._v(" Export session ")]
              ),
            ]
          ),
        ]),
        _c("input", {
          ref: "sessionImportInput",
          staticClass: "d-none",
          attrs: { type: "file", accept: "application/json,.json" },
          on: { change: _vm.onSessionImportFileChange },
        }),
      ]),
    ]),
    _c("div", { staticClass: "bn-body" }, [
      _vm.error && !_vm.loading && !_vm.biomarkerLoading
        ? _c("div", { staticClass: "alert alert-danger py-2 mb-3" }, [
            _vm._v(" " + _vm._s(_vm.error) + " "),
          ])
        : _vm._e(),
      _c("div", { staticClass: "bn-direction-infographic" }, [
        _c("img", {
          staticClass: "bn-direction-infographic__img",
          attrs: {
            src: _vm.directionInfographicSrc,
            alt: _vm.directionInfographicAlt,
          },
        }),
        _vm._m(0),
      ]),
      _c(
        "div",
        { staticClass: "bn-accordions" },
        [
          _vm.isForwardSearch
            ? [
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion bn-accordion--mechanism",
                    class: {
                      "bn-accordion--open": _vm.mechanismAccordionOpen,
                      "bn-accordion--suggesting": _vm.suggestionsOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.mechanismAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mechanismAccordionOpen =
                                !_vm.mechanismAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("1"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Inferred biological factor")]
                            ),
                            _vm.selectedMechanismHeaderLabel
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bn-header-mechanism-bubble",
                                    attrs: {
                                      title: _vm.selectedMechanismHeaderLabel,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedMechanismHeaderLabel
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mechanismAccordionOpen,
                            expression: "mechanismAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _c("div", { staticClass: "bn-search-panel" }, [
                          _c("div", { staticClass: "bn-search-row" }, [
                            _c("div", { staticClass: "bn-input-wrap" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userQuery,
                                    expression: "userQuery",
                                  },
                                ],
                                ref: "diseaseInput",
                                staticClass: "form-control",
                                class: {
                                  "bn-query-input--clearable":
                                    _vm.showSearchClear,
                                },
                                attrs: {
                                  id: "bn-disease-input",
                                  type: "text",
                                  placeholder:
                                    "Search a CFDE REVEAL mechanism (e.g. IL-12 signaling)",
                                  autocomplete: "off",
                                  "aria-label": "Mechanism",
                                },
                                domProps: { value: _vm.userQuery },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) return
                                      _vm.userQuery = $event.target.value
                                    },
                                    _vm.onQueryInput,
                                  ],
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "down",
                                          40,
                                          $event.key,
                                          ["Down", "ArrowDown"]
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.moveSuggestion(1)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "up",
                                          38,
                                          $event.key,
                                          ["Up", "ArrowUp"]
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.moveSuggestion(-1)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.onEnter.apply(null, arguments)
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "esc",
                                          27,
                                          $event.key,
                                          ["Esc", "Escape"]
                                        )
                                      )
                                        return null
                                      return _vm.closeSuggestions.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm.showSearchClear
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "bn-clear-bubble",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Clear search input",
                                        title: "Clear search input",
                                      },
                                      on: { click: _vm.clearSearchInput },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: "x",
                                          "aria-hidden": "true",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.suggestionsOpen &&
                              (_vm.flatSuggestions.length ||
                                _vm.suggestionsLoading)
                                ? _c(
                                    "ul",
                                    {
                                      staticClass: "bn-suggestions",
                                      attrs: { role: "listbox" },
                                    },
                                    [
                                      _vm.suggestionsLoading &&
                                      !_vm.flatSuggestions.length
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "bn-suggestion bn-suggestion--muted",
                                            },
                                            [_vm._v(" Searching mechanisms… ")]
                                          )
                                        : _vm._e(),
                                      _vm._l(_vm.flatSuggestions, function (s) {
                                        return _c(
                                          "li",
                                          {
                                            key: "m-" + s.iri,
                                            staticClass: "bn-suggestion",
                                            class: {
                                              "bn-suggestion--active":
                                                s.flatIndex ===
                                                _vm.suggestionIndex,
                                            },
                                            attrs: { role: "option" },
                                            on: {
                                              mousedown: function ($event) {
                                                $event.preventDefault()
                                                return _vm.selectSuggestion(s)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "bn-suggestion-label",
                                              },
                                              [_vm._v(_vm._s(s.label))]
                                            ),
                                          ]
                                        )
                                      }),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-cfde btn-sm bn-find-diseases-btn",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.loading || !_vm.searchNeedle,
                                },
                                on: { click: _vm.runSearch },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.loading
                                        ? "Finding associated diseases…"
                                        : "Find associated diseases"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: { "bn-accordion--open": _vm.diseasesAccordionOpen },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.diseasesAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.diseasesAccordionOpen =
                                !_vm.diseasesAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("2"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Associated diseases")]
                            ),
                            _vm.associatedDiseases.length
                              ? _c(
                                  "span",
                                  { staticClass: "bn-accordion-count" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.selectedDiseaseCount) +
                                        "/" +
                                        _vm._s(_vm.associatedDiseases.length) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.diseasesAccordionOpen,
                            expression: "diseasesAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _vm.loading
                          ? _c(
                              "div",
                              {
                                staticClass: "bn-status bn-status--loading",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", {
                                  staticClass: "bn-spinner",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.loadingMessage ||
                                        "Finding associated diseases…"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : !_vm.searched
                          ? [
                              _c("p", { staticClass: "bn-filter-empty" }, [
                                _vm._v(
                                  " Choose a mechanism in step 1, then click Find associated diseases. "
                                ),
                              ]),
                            ]
                          : !_vm.associatedDiseases.length
                          ? [
                              _c("p", { staticClass: "bn-filter-empty" }, [
                                _vm._v(
                                  " No associated MONDO diseases for this mechanism. "
                                ),
                              ]),
                            ]
                          : [
                              _vm._m(1),
                              _c("div", { staticClass: "bn-table-intro-row" }, [
                                _c("p", { staticClass: "bn-table-intro" }, [
                                  _vm._v(
                                    " Review the disease evidence, then choose which diseases should be used to retrieve biomarkers. "
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-cfde btn-sm bn-find-biomarkers-btn",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.biomarkerLoading ||
                                        !_vm.selectedDiseaseCount,
                                    },
                                    on: { click: _vm.fetchBiomarkers },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.biomarkerLoading
                                            ? "Finding biomarkers…"
                                            : "Find biomarkers"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-sm table-hover bn-table",
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "bn-check-col",
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "checkbox",
                                              "aria-label":
                                                "Select all diseases",
                                            },
                                            domProps: {
                                              checked: _vm.allDiseasesSelected,
                                              indeterminate:
                                                _vm.someDiseasesSelected &&
                                                !_vm.allDiseasesSelected,
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleAllDiseases(
                                                  $event.target.checked
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v("Disease"),
                                      ]),
                                      _c(
                                        "th",
                                        { attrs: { scope: "col" } },
                                        [
                                          _vm._v(" Shared genes "),
                                          _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.top",
                                                value:
                                                  "Number of genes supporting both the selected factor and this disease. Click the count to list them.",
                                                expression:
                                                  "'Number of genes supporting both the selected factor and this disease. Click the count to list them.'",
                                                modifiers: {
                                                  hover: true,
                                                  top: true,
                                                },
                                              },
                                            ],
                                            staticClass: "bn-th-info",
                                            attrs: { icon: "info-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "th",
                                        { attrs: { scope: "col" } },
                                        [
                                          _vm._v(" Gene-profile similarity "),
                                          _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.top",
                                                value:
                                                  "Cosine similarity between the factor gene-evidence profile and the disease gene-evidence profile.",
                                                expression:
                                                  "'Cosine similarity between the factor gene-evidence profile and the disease gene-evidence profile.'",
                                                modifiers: {
                                                  hover: true,
                                                  top: true,
                                                },
                                              },
                                            ],
                                            staticClass: "bn-th-info",
                                            attrs: { icon: "info-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "th",
                                        { attrs: { scope: "col" } },
                                        [
                                          _vm._v(" Overlap significance "),
                                          _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.top",
                                                value:
                                                  "-log10 of the hypergeometric overlap p-value. Hover a cell for the exact p-value.",
                                                expression:
                                                  "'-log10 of the hypergeometric overlap p-value. Hover a cell for the exact p-value.'",
                                                modifiers: {
                                                  hover: true,
                                                  top: true,
                                                },
                                              },
                                            ],
                                            staticClass: "bn-th-info",
                                            attrs: { icon: "info-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "th",
                                        { attrs: { scope: "col" } },
                                        [
                                          _vm._v(" Combined evidence score "),
                                          _c("b-icon", {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName:
                                                  "v-b-tooltip.hover.top",
                                                value:
                                                  "Ranking score for diseases against the selected factor, combining gene-profile similarity with overlap significance.",
                                                expression:
                                                  "'Ranking score for diseases against the selected factor, combining gene-profile similarity with overlap significance.'",
                                                modifiers: {
                                                  hover: true,
                                                  top: true,
                                                },
                                              },
                                            ],
                                            staticClass: "bn-th-info",
                                            attrs: { icon: "info-circle" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        _vm.diseasePageRows,
                                        function (row) {
                                          return [
                                            _c("tr", { key: row.disease }, [
                                              _c(
                                                "td",
                                                { staticClass: "bn-check-col" },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      "aria-label":
                                                        "Select " +
                                                        (row.diseaseLabel ||
                                                          row.disease),
                                                    },
                                                    domProps: {
                                                      checked:
                                                        _vm.isDiseaseSelected(
                                                          row.disease
                                                        ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.setDiseaseSelected(
                                                          row.disease,
                                                          $event.target.checked
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c("td", [
                                                row.disease
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: row.disease,
                                                          target: "_blank",
                                                          rel: "noopener noreferrer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row.diseaseLabel ||
                                                              row.disease
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.diseaseLabel ||
                                                            "—"
                                                        )
                                                      ),
                                                    ]),
                                              ]),
                                              _c("td", [
                                                (row.supportingGenes || [])
                                                  .length
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "bn-shared-gene-toggle",
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.toggleSupportingGenes(
                                                              row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row.sharedGeneCount
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          row.sharedGeneCount ||
                                                            0
                                                        )
                                                      ),
                                                    ]),
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatScore(
                                                      row.geneEvidenceSimilarity,
                                                      4
                                                    )
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "td",
                                                {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      value:
                                                        _vm.overlapPValueTooltip(
                                                          row.overlapPValue
                                                        ),
                                                      expression:
                                                        "\n                                                    overlapPValueTooltip(row.overlapPValue)\n                                                ",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true,
                                                      },
                                                    },
                                                  ],
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.formatScore(
                                                          row.overlapNegLog10P,
                                                          2
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatScore(
                                                      row.combinedScore,
                                                      4
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _vm.isSupportingGenesExpanded(
                                              row.disease
                                            )
                                              ? _c(
                                                  "tr",
                                                  {
                                                    key: row.disease + "-genes",
                                                    staticClass:
                                                      "bn-subtable-row",
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "6" },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "bn-subtable-wrap",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bn-supporting-genes-expand",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    "Supporting genes"
                                                                  ),
                                                                ]),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatSupportingGenesList(
                                                                        row.supportingGenes
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm.associatedDiseases.length > _vm.perPage
                                ? _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center mt-2",
                                    attrs: {
                                      "total-rows":
                                        _vm.associatedDiseases.length,
                                      "per-page": _vm.perPage,
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.mechanismPage,
                                      callback: function ($$v) {
                                        _vm.mechanismPage = $$v
                                      },
                                      expression: "mechanismPage",
                                    },
                                  })
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: {
                      "bn-accordion--open": _vm.biomarkersAccordionOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.biomarkersAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.biomarkersAccordionOpen =
                                !_vm.biomarkersAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("3"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Biomarkers")]
                            ),
                            _vm.biomarkersFetched
                              ? _c(
                                  "span",
                                  { staticClass: "bn-accordion-count" },
                                  [_vm._v(" " + _vm._s(_vm.rows.length) + " ")]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.biomarkersAccordionOpen,
                            expression: "biomarkersAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _vm.biomarkerLoading
                          ? _c(
                              "div",
                              {
                                staticClass: "bn-status bn-status--loading",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", {
                                  staticClass: "bn-spinner",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.loadingMessage ||
                                        "Finding biomarkers…"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : !_vm.biomarkersFetched
                          ? [
                              _c("p", { staticClass: "bn-filter-empty" }, [
                                _vm._v(
                                  " Select diseases above, then click Find biomarkers. "
                                ),
                              ]),
                            ]
                          : [
                              _vm._m(2),
                              _c("div", { staticClass: "bn-table-intro-row" }, [
                                _c("p", { staticClass: "bn-table-intro" }, [
                                  _vm._v(
                                    " Review the biomarker evidence, then generate a mechanistic feedback summary. "
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-cfde btn-sm",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.mechanismLinkLoading ||
                                        !_vm.biomarkersFetched ||
                                        !_vm.filteredRows.length,
                                    },
                                    on: {
                                      click: _vm.generateMechanismLinkSummary,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.mechanismLinkLoading
                                            ? "Generating…"
                                            : _vm.mechanismLinkSummary
                                                .status === "done"
                                            ? "Regenerate summary"
                                            : "Generate summary"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.uniqueRoleLabels.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bn-type-filters",
                                      attrs: {
                                        role: "group",
                                        "aria-label":
                                          "Filter by biomarker role",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "bn-type-filters-label",
                                        },
                                        [_vm._v("Roles:")]
                                      ),
                                      _vm._l(
                                        _vm.uniqueRoleLabels,
                                        function (label) {
                                          return _c(
                                            "button",
                                            {
                                              key: label,
                                              staticClass: "bn-type-bubble",
                                              class: {
                                                "bn-type-bubble--off":
                                                  !_vm.isTypeVisible(label),
                                              },
                                              attrs: {
                                                type: "button",
                                                "aria-pressed":
                                                  _vm.isTypeVisible(label)
                                                    ? "true"
                                                    : "false",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleTypeFilter(
                                                    label
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: _vm.isTypeVisible(label)
                                                    ? "eye-fill"
                                                    : "eye-slash",
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(" " + _vm._s(label) + " "),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm.showBiomarkerDiseaseFilters ||
                              _vm.sharedGeneMappingBubbleLabel
                                ? _c(
                                    "div",
                                    { staticClass: "bn-disease-filters-block" },
                                    [
                                      _vm.showBiomarkerDiseaseFilters
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "bn-type-filters",
                                              attrs: {
                                                role: "group",
                                                "aria-label":
                                                  "Filter biomarkers by disease",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bn-type-filters-label",
                                                },
                                                [_vm._v("Diseases:")]
                                              ),
                                              _vm._l(
                                                _vm.uniqueBiomarkerDiseaseFilters,
                                                function (d) {
                                                  return _c(
                                                    "button",
                                                    {
                                                      key: "bio-" + d.iri,
                                                      staticClass:
                                                        "bn-type-bubble",
                                                      class: {
                                                        "bn-type-bubble--off":
                                                          !_vm.isDiseaseVisible(
                                                            d.iri
                                                          ),
                                                      },
                                                      attrs: {
                                                        type: "button",
                                                        "aria-pressed":
                                                          _vm.isDiseaseVisible(
                                                            d.iri
                                                          )
                                                            ? "true"
                                                            : "false",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleDiseaseFilter(
                                                            d.iri
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon: _vm.isDiseaseVisible(
                                                            d.iri
                                                          )
                                                            ? "eye-fill"
                                                            : "eye-slash",
                                                          "aria-hidden": "true",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(d.label) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm.sharedGeneMappingBubbleLabel
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "bn-type-filters",
                                              attrs: {
                                                role: "group",
                                                "aria-label":
                                                  "Filter biomarkers by shared gene overlap",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "bn-type-filters-label",
                                                },
                                                [
                                                  _vm._v(
                                                    " Associated gene to shared gene mapping: "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "bn-type-bubble",
                                                  class: {
                                                    "bn-type-bubble--off":
                                                      !_vm.mappedGeneOverlapFilter,
                                                  },
                                                  attrs: {
                                                    type: "button",
                                                    "aria-pressed":
                                                      _vm.mappedGeneOverlapFilter
                                                        ? "true"
                                                        : "false",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleMappedGeneOverlapFilter,
                                                  },
                                                },
                                                [
                                                  _c("b-icon", {
                                                    attrs: {
                                                      icon: _vm.mappedGeneOverlapFilter
                                                        ? "eye-fill"
                                                        : "eye-slash",
                                                      "aria-hidden": "true",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.sharedGeneMappingBubbleLabel
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.rows.length
                                ? _c("p", { staticClass: "bn-filter-empty" }, [
                                    _vm._v(
                                      " No biomarkers found for the selected diseases. "
                                    ),
                                  ])
                                : !_vm.filteredRows.length
                                ? _c("p", { staticClass: "bn-filter-empty" }, [
                                    _vm._v(
                                      " No rows for the selected filters. "
                                    ),
                                  ])
                                : _c(
                                    "div",
                                    { staticClass: "bn-table-toolbar" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "bn-table-toolbar-label",
                                        },
                                        [_vm._v("Download table:")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "bn-table-download-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadBiomarkerTable(
                                                "csv"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" CSV ")]
                                      ),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "bn-table-download-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadBiomarkerTable(
                                                "tsv"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(" TSV ")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "bn-table-toolbar-meta text-muted",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.filteredRows.length) +
                                              " row" +
                                              _vm._s(
                                                _vm.filteredRows.length === 1
                                                  ? ""
                                                  : "s"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                              _vm.filteredRows.length
                                ? _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-sm table-hover bn-table",
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Biomarker")]
                                          ),
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Associated gene")]
                                          ),
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Roles")]
                                          ),
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [_vm._v("Diseases")]
                                          ),
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [
                                              _vm._v(" Records "),
                                              _c("b-icon", {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.top",
                                                    value:
                                                      "Number of distinct BiomarkerKB assertion records linking this biomarker to the input diseases via any role (diagnostic, monitoring, prognostic, or susceptibility/risk).",
                                                    expression:
                                                      "'Number of distinct BiomarkerKB assertion records linking this biomarker to the input diseases via any role (diagnostic, monitoring, prognostic, or susceptibility/risk).'",
                                                    modifiers: {
                                                      hover: true,
                                                      top: true,
                                                    },
                                                  },
                                                ],
                                                staticClass: "bn-th-info",
                                                attrs: { icon: "info-circle" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          _vm.pageRows,
                                          function (row, idx) {
                                            return _c(
                                              "tr",
                                              {
                                                key: row.biomarker + "-" + idx,
                                              },
                                              [
                                                _c("td", [
                                                  row.biomarker
                                                    ? _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: row.biomarker,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.biomarkerDisplayLabel(
                                                                row
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.biomarkerDisplayLabel(
                                                              row
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "bn-gene-cell",
                                                  },
                                                  [
                                                    _vm.rowAssociatedGenes(row)
                                                      .length
                                                      ? _vm._l(
                                                          _vm.rowAssociatedGenes(
                                                            row
                                                          ),
                                                          function (
                                                            gene,
                                                            geneIdx
                                                          ) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key:
                                                                  row.biomarker +
                                                                  "-gene-" +
                                                                  gene +
                                                                  "-" +
                                                                  geneIdx,
                                                              },
                                                              [
                                                                geneIdx
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " | "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "bn-gene-mapped":
                                                                        _vm.isRowGeneShared(
                                                                          row,
                                                                          gene
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        gene
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _c("span", [
                                                          _vm._v("—"),
                                                        ]),
                                                  ],
                                                  2
                                                ),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(row.roles || "—")
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(row.diseases || "—")
                                                  ),
                                                ]),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      row.recordCount || "—"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.filteredRows.length > _vm.perPage
                                ? _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center mt-2",
                                    attrs: {
                                      "total-rows": _vm.filteredRows.length,
                                      "per-page": _vm.perPage,
                                      size: "sm",
                                    },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function ($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage",
                                    },
                                  })
                                : _vm._e(),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: {
                      "bn-accordion--open": _vm.mechanismLinkAccordionOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.mechanismLinkAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: { click: _vm.toggleMechanismLinkAccordion },
                        },
                        [
                          _vm._m(3),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mechanismLinkAccordionOpen,
                            expression: "mechanismLinkAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        !_vm.biomarkersFetched
                          ? _c("p", { staticClass: "bn-filter-empty" }, [
                              _vm._v(
                                " Complete step 3 to generate a mechanistic feedback summary. "
                              ),
                            ])
                          : !_vm.filteredRows.length
                          ? _c("p", { staticClass: "bn-filter-empty" }, [
                              _vm._v(
                                " No biomarker rows match the current filters. "
                              ),
                            ])
                          : [
                              _vm.mechanismLinkLoading
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bn-status bn-status--loading mb-2",
                                      attrs: { role: "status" },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "bn-spinner",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.mechanismLinkStatus ||
                                              "Generating mechanistic summary…"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm.mechanismLinkSummary.status === "error"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "alert alert-danger py-2 bn-mechanism-link-error",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.mechanismLinkSummary.error ||
                                              "Summary generation failed."
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm.mechanismLinkSummary.status === "done" &&
                                  _vm.mechanismLinkSummary.data
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bn-mechanism-link-result-wrap",
                                    },
                                    [
                                      _c("biomarker-mechanism-link-summary", {
                                        attrs: {
                                          summary:
                                            _vm.mechanismLinkSummary.data,
                                          "mechanism-label":
                                            _vm.searchedFactorLabel ||
                                            _vm.lastNeedle ||
                                            "Mechanism",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "p",
                                    { staticClass: "bn-filter-empty mb-0" },
                                    [
                                      _vm._v(
                                        " Use Generate summary in step 3 to run one LLM analysis over the full filtered biomarker table. "
                                      ),
                                    ]
                                  ),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion bn-accordion--mechanism",
                    class: {
                      "bn-accordion--open": _vm.reverseBiomarkerAccordionOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.reverseBiomarkerAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.reverseBiomarkerAccordionOpen =
                                !_vm.reverseBiomarkerAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("1"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Candidate biomarker")]
                            ),
                            _vm.reverseResolved && _vm.reverseResolved.found
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "bn-header-mechanism-bubble",
                                    attrs: {
                                      title: _vm.reverseSeedBiomarkerLabel,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.reverseSeedBiomarkerLabel) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.reverseBiomarkerAccordionOpen,
                            expression: "reverseBiomarkerAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _c("div", { staticClass: "bn-search-panel" }, [
                          _c("div", { staticClass: "bn-search-row" }, [
                            _c("div", { staticClass: "bn-input-wrap" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reverseUserQuery,
                                    expression: "reverseUserQuery",
                                  },
                                ],
                                ref: "reverseBiomarkerInput",
                                staticClass: "form-control",
                                class: {
                                  "bn-query-input--clearable":
                                    !!_vm.reverseUserQuery.trim(),
                                },
                                attrs: {
                                  id: "bn-reverse-biomarker-input",
                                  type: "text",
                                  placeholder:
                                    "Search a SNP or gene (e.g. rs7903146, TCF7L2)",
                                  autocomplete: "off",
                                  "aria-label": "Biomarker SNP or gene",
                                },
                                domProps: { value: _vm.reverseUserQuery },
                                on: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.runReverseDiseaseSearch.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.reverseUserQuery = $event.target.value
                                  },
                                },
                              }),
                              _vm.reverseUserQuery.trim()
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "bn-clear-bubble",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Clear biomarker search",
                                        title: "Clear biomarker search",
                                      },
                                      on: {
                                        click: _vm.clearReverseBiomarkerSearch,
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        attrs: {
                                          icon: "x",
                                          "aria-hidden": "true",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-cfde btn-sm bn-find-diseases-btn",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    _vm.reverseLoading ||
                                    !_vm.reverseUserQuery.trim(),
                                },
                                on: { click: _vm.runReverseDiseaseSearch },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.reverseLoading
                                        ? _vm.reverseLoadingMessage ||
                                            "Finding associated diseases…"
                                        : "Find associated diseases"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: {
                      "bn-accordion--open": _vm.reverseDiseasesAccordionOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.reverseDiseasesAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.reverseDiseasesAccordionOpen =
                                !_vm.reverseDiseasesAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("2"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Associated diseases")]
                            ),
                            _vm.reverseAssociatedDiseases.length
                              ? _c(
                                  "span",
                                  { staticClass: "bn-accordion-count" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.reverseSelectedDiseaseCount
                                        ) +
                                        "/" +
                                        _vm._s(
                                          _vm.reverseAssociatedDiseases.length
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.reverseDiseasesAccordionOpen,
                            expression: "reverseDiseasesAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _vm.reverseLoading
                          ? _c(
                              "div",
                              {
                                staticClass: "bn-status bn-status--loading",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", {
                                  staticClass: "bn-spinner",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.reverseLoadingMessage ||
                                        "Finding associated diseases…"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm.reverseResolved && !_vm.reverseResolved.found
                          ? _c(
                              "div",
                              {
                                staticClass: "alert alert-warning py-2 mb-0",
                                attrs: { role: "alert" },
                              },
                              [
                                _vm._v(" No BiomarkerKB match for "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.reverseResolved.needle)),
                                ]),
                                _vm._v(
                                  ". Try another SNP rsID or gene symbol. "
                                ),
                              ]
                            )
                          : _vm.reverseResolved && _vm.reverseResolved.found
                          ? [
                              !_vm.reverseAssociatedDiseases.length
                                ? _c(
                                    "p",
                                    { staticClass: "bn-filter-empty mb-0" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.reverseDiseasesEmptyCopy) +
                                          " "
                                      ),
                                    ]
                                  )
                                : [
                                    _vm._m(4),
                                    _c(
                                      "div",
                                      { staticClass: "bn-table-intro-row" },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "bn-table-intro" },
                                          [
                                            _vm._v(
                                              " Review the disease evidence, then choose which diseases should be used to find mechanisms. "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-cfde btn-sm",
                                            attrs: {
                                              type: "button",
                                              disabled:
                                                _vm.reverseMechanismLoading ||
                                                !_vm.reverseSelectedDiseaseCount,
                                            },
                                            on: {
                                              click:
                                                _vm.runReverseMechanismSearch,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.reverseMechanismLoading
                                                    ? _vm.reverseMechanismLoadingMessage ||
                                                        "Finding mechanisms…"
                                                    : "Find mechanisms"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table table-sm table-hover bn-table",
                                      },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              {
                                                staticClass: "bn-check-col",
                                                attrs: { scope: "col" },
                                              },
                                              [
                                                _c("input", {
                                                  attrs: {
                                                    type: "checkbox",
                                                    "aria-label":
                                                      "Select all reverse diseases",
                                                  },
                                                  domProps: {
                                                    checked:
                                                      _vm.allReverseDiseasesSelected,
                                                    indeterminate:
                                                      _vm.someReverseDiseasesSelected &&
                                                      !_vm.allReverseDiseasesSelected,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.toggleAllReverseDiseases(
                                                        $event.target.checked
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Disease")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Roles")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [
                                                _vm._v(" Biomarkers "),
                                                _c("b-icon", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      value:
                                                        "Distinct biomarker entities linked to this disease for the searched SNP or gene.",
                                                      expression:
                                                        "\n                                                        'Distinct biomarker entities linked to this disease for the searched SNP or gene.'\n                                                    ",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass: "bn-th-info",
                                                  attrs: {
                                                    icon: "info-circle",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [
                                                _vm._v(" Records "),
                                                _c("b-icon", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      value:
                                                        "BiomarkerKB assertion records linking the searched SNP or gene to this disease.",
                                                      expression:
                                                        "\n                                                        'BiomarkerKB assertion records linking the searched SNP or gene to this disease.'\n                                                    ",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass: "bn-th-info",
                                                  attrs: {
                                                    icon: "info-circle",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.reverseDiseasePageRows,
                                            function (row) {
                                              return _c(
                                                "tr",
                                                {
                                                  key: "rev-dis-" + row.disease,
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "bn-check-col",
                                                    },
                                                    [
                                                      _c("input", {
                                                        attrs: {
                                                          type: "checkbox",
                                                          "aria-label":
                                                            "Select " +
                                                            (row.diseaseLabel ||
                                                              row.disease),
                                                        },
                                                        domProps: {
                                                          checked:
                                                            _vm.isReverseDiseaseSelected(
                                                              row.disease
                                                            ),
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.setReverseDiseaseSelected(
                                                              row.disease,
                                                              $event.target
                                                                .checked
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _c("td", [
                                                    row.disease
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: row.disease,
                                                              target: "_blank",
                                                              rel: "noopener noreferrer",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                row.diseaseLabel ||
                                                                  row.disease
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              row.diseaseLabel ||
                                                                "—"
                                                            )
                                                          ),
                                                        ]),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(row.roles || "—")
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(row.biomarkerCount)
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(row.recordCount)
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _vm.reverseAssociatedDiseases.length >
                                    _vm.perPage
                                      ? _c("b-pagination", {
                                          staticClass:
                                            "pagination-sm justify-content-center mt-2",
                                          attrs: {
                                            "total-rows":
                                              _vm.reverseAssociatedDiseases
                                                .length,
                                            "per-page": _vm.perPage,
                                            size: "sm",
                                          },
                                          model: {
                                            value: _vm.reverseDiseasePage,
                                            callback: function ($$v) {
                                              _vm.reverseDiseasePage = $$v
                                            },
                                            expression: "reverseDiseasePage",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                            ]
                          : _c("p", { staticClass: "bn-filter-empty mb-0" }, [
                              _vm._v(
                                " " + _vm._s(_vm.reverseDiseasesEmptyCopy) + " "
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: {
                      "bn-accordion--open": _vm.reverseMechanismsAccordionOpen,
                    },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.reverseMechanismsAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.reverseMechanismsAccordionOpen =
                                !_vm.reverseMechanismsAccordionOpen
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "bn-accordion-title" }, [
                            _c("span", { staticClass: "bn-accordion-step" }, [
                              _vm._v("3"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "bn-accordion-title-text" },
                              [_vm._v("Candidate mechanisms")]
                            ),
                            _vm.reverseMechanisms.length
                              ? _c(
                                  "span",
                                  { staticClass: "bn-accordion-count" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.filteredReverseMechanisms.length
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.reverseMechanismsAccordionOpen,
                            expression: "reverseMechanismsAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        _vm.reverseMechanismLoading
                          ? _c(
                              "div",
                              {
                                staticClass: "bn-status bn-status--loading",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", {
                                  staticClass: "bn-spinner",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.reverseMechanismLoadingMessage ||
                                        "Finding mechanisms…"
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm.reverseMechanisms.length
                          ? [
                              _vm._m(5),
                              _c("div", { staticClass: "bn-table-intro-row" }, [
                                _c("p", { staticClass: "bn-table-intro" }, [
                                  _vm._v(
                                    " Review the mechanism evidence, then generate a mechanistic feedback summary. "
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-cfde btn-sm",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.reverseMechanismLinkLoading ||
                                        !_vm.filteredReverseMechanisms.length,
                                    },
                                    on: {
                                      click:
                                        _vm.generateReverseMechanismLinkSummary,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.reverseMechanismLinkLoading
                                            ? "Generating…"
                                            : _vm.reverseMechanismLinkSummary
                                                .status === "done"
                                            ? "Regenerate summary"
                                            : "Generate summary"
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm.showReverseMechanismDiseaseFilters
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "bn-type-filters",
                                      attrs: {
                                        role: "group",
                                        "aria-label":
                                          "Filter mechanisms by disease",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "bn-type-filters-label",
                                        },
                                        [_vm._v("Diseases:")]
                                      ),
                                      _vm._l(
                                        _vm.uniqueReverseMechanismDiseaseFilters,
                                        function (d) {
                                          return _c(
                                            "button",
                                            {
                                              key: "rev-mech-dis-" + d.iri,
                                              staticClass: "bn-type-bubble",
                                              class: {
                                                "bn-type-bubble--off":
                                                  !_vm.isReverseMechanismDiseaseVisible(
                                                    d.iri
                                                  ),
                                              },
                                              attrs: {
                                                type: "button",
                                                "aria-pressed":
                                                  _vm.isReverseMechanismDiseaseVisible(
                                                    d.iri
                                                  )
                                                    ? "true"
                                                    : "false",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleReverseMechanismDiseaseFilter(
                                                    d.iri
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("b-icon", {
                                                attrs: {
                                                  icon: _vm.isReverseMechanismDiseaseVisible(
                                                    d.iri
                                                  )
                                                    ? "eye-fill"
                                                    : "eye-slash",
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(
                                                " " + _vm._s(d.label) + " "
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              !_vm.filteredReverseMechanisms.length
                                ? _c("p", { staticClass: "bn-filter-empty" }, [
                                    _vm._v(
                                      " No mechanisms for the selected disease filters. "
                                    ),
                                  ])
                                : [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table table-sm table-hover bn-table",
                                      },
                                      [
                                        _c("thead", [
                                          _c("tr", [
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Mechanism")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [
                                                _vm._v(" Support "),
                                                _c("b-icon", {
                                                  directives: [
                                                    {
                                                      name: "b-tooltip",
                                                      rawName:
                                                        "v-b-tooltip.hover.top",
                                                      value:
                                                        "How this factor overlaps the seed gene(s) and selected BiomarkerKB diseases in CFDE REVEAL.",
                                                      expression:
                                                        "\n                                                    'How this factor overlaps the seed gene(s) and selected BiomarkerKB diseases in CFDE REVEAL.'\n                                                ",
                                                      modifiers: {
                                                        hover: true,
                                                        top: true,
                                                      },
                                                    },
                                                  ],
                                                  staticClass: "bn-th-info",
                                                  attrs: {
                                                    icon: "info-circle",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Gene loading")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Trait weight")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Genes")]
                                            ),
                                            _c(
                                              "th",
                                              { attrs: { scope: "col" } },
                                              [_vm._v("Diseases")]
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.reverseMechanismPageRows,
                                            function (row) {
                                              return _c(
                                                "tr",
                                                {
                                                  key: "rev-mech-" + row.factor,
                                                },
                                                [
                                                  _c("td", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "bn-mech-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            row.factorLabel ||
                                                              row.factor
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _c(
                                                      "span",
                                                      {
                                                        class:
                                                          _vm.reverseSupportBadgeClass(
                                                            row
                                                          ),
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              row.supportLabel
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatScore(
                                                          row.geneWeight,
                                                          4
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatScore(
                                                          row.traitWeight,
                                                          4
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          row.geneSymbols &&
                                                            row.geneSymbols
                                                              .length
                                                            ? row.geneSymbols.join(
                                                                ", "
                                                              )
                                                            : "—"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                  _c(
                                                    "td",
                                                    [
                                                      row.supportingDiseases &&
                                                      row.supportingDiseases
                                                        .length
                                                        ? [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.supportingDiseases
                                                                    .map(
                                                                      (d) =>
                                                                        d.diseaseLabel ||
                                                                        d.disease
                                                                    )
                                                                    .join(" | ")
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        : row.matchedDiseaseLabels &&
                                                          row
                                                            .matchedDiseaseLabels
                                                            .length
                                                        ? [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  row.matchedDiseaseLabels.join(
                                                                    " | "
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "text-muted",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "(label)"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : [_vm._v("—")],
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _vm.filteredReverseMechanisms.length >
                                    _vm.perPage
                                      ? _c("b-pagination", {
                                          staticClass:
                                            "bn-pagination mt-2 mb-0",
                                          attrs: {
                                            "total-rows":
                                              _vm.filteredReverseMechanisms
                                                .length,
                                            "per-page": _vm.perPage,
                                            size: "sm",
                                          },
                                          model: {
                                            value: _vm.reverseMechanismPage,
                                            callback: function ($$v) {
                                              _vm.reverseMechanismPage = $$v
                                            },
                                            expression: "reverseMechanismPage",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                            ]
                          : _c("p", { staticClass: "bn-filter-empty mb-0" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.reverseMechanismsEmptyCopy) +
                                  " "
                              ),
                            ]),
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "bn-accordion",
                    class: { "bn-accordion--open": _vm.reverseAiAccordionOpen },
                  },
                  [
                    _c("div", { staticClass: "bn-accordion-header" }, [
                      _c(
                        "button",
                        {
                          staticClass: "bn-accordion-trigger",
                          attrs: {
                            type: "button",
                            "aria-expanded": _vm.reverseAiAccordionOpen
                              ? "true"
                              : "false",
                          },
                          on: { click: _vm.toggleReverseAiAccordion },
                        },
                        [
                          _vm._m(6),
                          _c("span", {
                            staticClass: "bn-accordion-chevron",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.reverseAiAccordionOpen,
                            expression: "reverseAiAccordionOpen",
                          },
                        ],
                        staticClass: "bn-accordion-panel",
                      },
                      [
                        !_vm.reverseMechanisms.length
                          ? _c("p", { staticClass: "bn-filter-empty" }, [
                              _vm._v(
                                " Complete step 3 to generate a reverse mechanistic feedback summary. "
                              ),
                            ])
                          : !_vm.filteredReverseMechanisms.length
                          ? _c("p", { staticClass: "bn-filter-empty" }, [
                              _vm._v(
                                " No mechanisms match the current disease filters. "
                              ),
                            ])
                          : [
                              _vm.reverseMechanismLinkLoading
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bn-status bn-status--loading mb-2",
                                      attrs: { role: "status" },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "bn-spinner",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.reverseMechanismLinkStatus ||
                                              "Generating reverse mechanistic summary…"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm.reverseMechanismLinkSummary.status ===
                                  "error"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "alert alert-danger py-2 bn-mechanism-link-error",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.reverseMechanismLinkSummary
                                              .error ||
                                              "Summary generation failed."
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm.reverseMechanismLinkSummary.status ===
                                    "done" &&
                                  _vm.reverseMechanismLinkSummary.data
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bn-mechanism-link-result-wrap",
                                    },
                                    [
                                      _c(
                                        "biomarker-reverse-mechanism-link-summary",
                                        {
                                          attrs: {
                                            summary:
                                              _vm.reverseMechanismLinkSummary
                                                .data,
                                            "seed-biomarker-label":
                                              _vm.reverseSeedBiomarkerLabel,
                                          },
                                        }
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "p",
                                    { staticClass: "bn-filter-empty mb-0" },
                                    [
                                      _vm._v(
                                        " Use Generate summary in step 3 to run one LLM analysis over the seed biomarker, selected diseases, and overlapping CFDE mechanisms. "
                                      ),
                                    ]
                                  ),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticStyle: { "text-align": "center" } }, [
      _vm._v(" Biomarkers were derived from "),
      _c(
        "a",
        { attrs: { href: "https://biomarkerkb.org/", target: "_blank" } },
        [_vm._v("BiomarkerKB")]
      ),
      _vm._v(
        ", a CFDE partnership aimed at categorizing and integrating multi-source biomarker data. "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bn-method-note" }, [
      _c("div", [
        _c("strong", [_vm._v("Disease ranking from shared genetic evidence")]),
        _c("p", [
          _vm._v(
            " Diseases are ranked by a combined evidence score that blends gene-profile similarity with overlap significance (−log₁₀ hypergeometric p). Click a shared-gene count to list the supporting genes. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bn-method-note" }, [
      _c("div", [
        _c("strong", [_vm._v("AI summary generation")]),
        _c("p", [
          _vm._v(
            " After reviewing the biomarker table, generate one integrative summary that closes the loop from the selected factor through diseases and biomarkers back to mechanistic interpretation. The summary uses the filtered biomarker rows and top mechanism genes as grounding. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "bn-accordion-title" }, [
      _c("span", { staticClass: "bn-accordion-step" }, [_vm._v("4")]),
      _c("span", { staticClass: "bn-accordion-title-text" }, [
        _vm._v("Mechanistic feedback loop"),
      ]),
      _c(
        "span",
        {
          staticClass: "bn-ai-bubble",
          attrs: { title: "Uses Claude (Bedrock)" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bn-method-note" }, [
      _c("div", [
        _c("strong", [_vm._v("Disease links from BiomarkerKB evidence")]),
        _c("p", [
          _vm._v(
            " BiomarkerKB diseases linked to the searched SNP or gene are listed with role and record support. Select the diseases that should drive CFDE mechanism overlap in the next step. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bn-method-note" }, [
      _c("div", [
        _c("strong", [_vm._v("AI summary generation")]),
        _c("p", [
          _vm._v(
            " After reviewing the overlapping CFDE mechanisms, generate one integrative summary that closes the loop from the seed biomarker through selected diseases back to candidate mechanisms. The summary uses the filtered mechanism rows and seed genes as grounding. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "bn-accordion-title" }, [
      _c("span", { staticClass: "bn-accordion-step" }, [_vm._v("4")]),
      _c("span", { staticClass: "bn-accordion-title-text" }, [
        _vm._v("Mechanistic feedback loop"),
      ]),
      _c(
        "span",
        {
          staticClass: "bn-ai-bubble",
          attrs: { title: "Uses Claude (Bedrock)" },
        },
        [_vm._v("AI")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }